import { useQuery } from "@tanstack/react-query";
import { fetchCountries } from "../../api/countries";
import type { CountryDTO } from "@shared/contracts";
import { STALE_TIME } from "../../utils/constants";

export function useCountries() {
  return useQuery<CountryDTO[]>({
    queryKey: ["countries"],
    queryFn: ({ signal }) => fetchCountries(signal),
    staleTime: STALE_TIME,
  });
}